import React, { useState } from "react";
import { connect } from "react-redux";
import ResponsiveDrawer from "../components/ResponsiveDrawer";
import {
  Box,
  Grid,
  TextField,
  Typography,
  Button,
  Modal,
  LinearProgress,
  IconButton,
  InputAdornment,
} from "@mui/material";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import { makeStyles } from "@material-ui/core";
import { Redirect } from "react-router-dom";
import { MdError, MdCheckCircle } from "react-icons/md";

import { useHistory } from "react-router";

const useStyles = makeStyles((theme) => ({
  root: {
    minHeight: "100vh",
    backgroundColor: "#F7F8FA",
  },
  toolbar: {
    height: "64px",
  },
  modal: {
    display: "flex",
    flexDirection: "column",
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: "500px",
    backgroundColor: "#fff",
    padding: "20px",
    borderRadius: "12px",
  },
  info: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    flex: 1,
    backgroundColor: "#fff",
    borderRadius: "12px",
    boxShadow: "0px 2px 6px #0000000a",
    padding: "20px",
    maxWidth: "600px",
  },
  rowReverse: {
    display: "flex",
    flexDirection: "row-reverse",
  },
}));

function Settings(props) {
  const classes = useStyles();

  const [oldEmail, setOldEmail] = useState("");
  const [newEmail, setNewEmail] = useState("");
  const [confirmEmail, setConfirmEmail] = useState("");
  const [oldPass, setOldPass] = useState("");
  const [newPass, setNewPass] = useState("");
  const [confirmPass, setConfirmPass] = useState("");
  const [open, setOpen] = useState(false);
  const [openWait, setOpenWait] = useState(false);
  const [openFailed, setOpenFailed] = useState(false);
  const [openSuccess, setOpenSuccess] = useState(false);
  const [messageFailed, setMessageFailed] = useState("");
  const [showPass, setShowPass] = useState(false);

  const history = useHistory();

  let tokenStorage = null;

  const handleClickShowPassword = () => {
    setShowPass(!showPass);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleSuccess = () => {
    localStorage.clear();
    history.push("/");
  };

  const handleChangePass = () => {
    changePass();
    setOpenWait(true);
  };

  const changeEmail = async () => {
    setOpen(false);
    setOpenWait(true);
    const sendReq = await fetch(
      "https://bck-bdx.carloapp.com/api/business/change_email",
      {
        method: "POST",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
          Version: "4.0",
          Authorization: `Bearer ${tokenStorage}`,
        },
        body: `old_email=${encodeURIComponent(
          oldEmail
        )}&new_email=${newEmail}&new_email_confirmation=${confirmEmail}`,
      }
    );
    const body = await sendReq.json();
    if (body.status === true) {
      setOpenWait(false);
      setOpenSuccess(true);
    } else {
      setOpenWait(false);
      setOpenFailed(true);
      setMessageFailed(body.message);
    }
  };

  const changePass = async () => {
    setOpen(false);
    setOpenWait(true);
    const sendReq = await fetch(
      "https://bck-bdx.carloapp.com/api/business/change_password",
      {
        method: "POST",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
          Version: "4.0",
          Authorization: `Bearer ${tokenStorage}`,
        },
        body: `old_password=${oldPass}&new_password=${newPass}&new_password_confirmation=${confirmPass}`,
      }
    );
    const body = await sendReq.json();
    if (body.status === true) {
      setOpenWait(false);
      setOpenSuccess(true);
    } else {
      setOpenWait(false);
      setOpenFailed(true);
      setMessageFailed(body.message);
    }
  };

  // Redirect user if not logged in
  let isLoggedIn = localStorage.getItem("token");
  if (isLoggedIn) {
    tokenStorage = isLoggedIn.slice(1, isLoggedIn.length - 1);
  }
  if (!props.token && !isLoggedIn) {
    return <Redirect to="/" />;
  }
  if (!props.token && isLoggedIn) {
    // passing the token in the redux store
    props.onSetToken(tokenStorage);
  }

  return (
    <Box sx={{ flexGrow: 1, display: "flex" }}>
      <ResponsiveDrawer />
      <Box className={classes.root} sx={{ flexGrow: 1, p: 3 }}>
        <div className={classes.toolbar}></div>
        <Grid container>
          <Grid item xs={12}>
            <Box>
              <Typography
                mb={3}
                variant="h6"
                sx={{
                  fontWeight: "bold",
                  // fontSize: "20px",
                  color: "#202731",
                }}
              >
                Paramètres
              </Typography>

              {/* box changement adresse email */}
              <Box className={classes.info}>
                <Typography
                  sx={{
                    fontWeight: "bold",
                    fontSize: "18px",
                    color: "#202731",
                  }}
                >
                  Changer votre adresse email
                </Typography>
                <TextField
                  required
                  id="outlined-required"
                  label="Adresse email actuelle"
                  margin="normal"
                  onChange={(e) =>
                    setOldEmail(e.target.value.toLocaleLowerCase())
                  }
                  value={oldEmail}
                />{" "}
                <TextField
                  required
                  id="outlined-required"
                  label="Nouvelle adresse email"
                  margin="normal"
                  onChange={(e) =>
                    setNewEmail(e.target.value.toLocaleLowerCase())
                  }
                  value={newEmail}
                />{" "}
                <TextField
                  required
                  id="outlined-required"
                  label="Confirmer nouvelle adresse email"
                  margin="normal"
                  onChange={(e) =>
                    setConfirmEmail(e.target.value.toLocaleLowerCase())
                  }
                  value={confirmEmail}
                />{" "}
                <Box mt={2} className={classes.rowReverse}>
                  <Button onClick={() => setOpen(true)}>Enregistrer</Button>
                </Box>
              </Box>

              {/* box changement mot de passe  */}
              <Box mt={3} className={classes.info}>
                <Typography
                  sx={{
                    fontWeight: "bold",
                    fontSize: "18px",
                    color: "#202731",
                  }}
                >
                  Changer votre mot de passe
                </Typography>
                <TextField
                  id="outlined-pass"
                  label="Mot de passe actuel"
                  type={showPass ? "text" : "password"}
                  margin="normal"
                  onChange={(e) => setOldPass(e.target.value)}
                  value={oldPass}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment>
                        <IconButton
                          aria-label="toggle password visibility"
                          onClick={handleClickShowPassword}
                        >
                          {showPass ? <VisibilityOff /> : <Visibility />}
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                />
                <TextField
                  id="outlined-pass"
                  label="Nouveau mot de passe"
                  type={showPass ? "text" : "password"}
                  margin="normal"
                  onChange={(e) => setNewPass(e.target.value)}
                  value={newPass}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment>
                        <IconButton
                          aria-label="toggle password visibility"
                          onClick={handleClickShowPassword}
                        >
                          {showPass ? <VisibilityOff /> : <Visibility />}
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                />
                <TextField
                  id="outlined-pass"
                  label="Confirmer nouveau mot de passe"
                  type={showPass ? "text" : "password"}
                  margin="normal"
                  onChange={(e) => setConfirmPass(e.target.value)}
                  value={confirmPass}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment>
                        <IconButton
                          aria-label="toggle password visibility"
                          onClick={handleClickShowPassword}
                        >
                          {showPass ? <VisibilityOff /> : <Visibility />}
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                />
                <Box mt={2} className={classes.rowReverse}>
                  <Button onClick={handleChangePass}>Enregistrer</Button>
                </Box>
              </Box>

              {/* Modal to confirm change of email */}

              <Modal
                open={open}
                onClose={handleClose}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
              >
                <Box className={classes.modal}>
                  <Typography variant="h6" sx={{ fontWeight: "bold" }}>
                    Changer votre adresse email
                  </Typography>
                  <Typography variant="subtitle1" mt={2}>
                    Pour valider le changement votre adresse email, vous serez
                    déconnecté et vous pourrez vous reconnecter avec vos
                    nouveaux identifiants.
                  </Typography>
                  <Box
                    mt={2}
                    sx={{ display: "flex", justifyContent: "space-between" }}
                  >
                    <Button
                      variant="contained"
                      size="large"
                      onClick={() => changeEmail()}
                      sx={{ width: "200px" }}
                    >
                      Confirmer
                    </Button>
                    <Button
                      variant="contained"
                      color="error"
                      size="large"
                      onClick={() => handleClose()}
                      sx={{ width: "200px" }}
                    >
                      Retour
                    </Button>
                  </Box>
                </Box>
              </Modal>

              {/* Modal to show progress/wait */}

              <Modal open={openWait}>
                <Box className={classes.modal}>
                  <LinearProgress />
                </Box>
              </Modal>

              {/* Modal to notify success and redirect user to log in page*/}

              <Modal open={openSuccess}>
                <Box className={classes.modal}>
                  <IconButton color="primary" className={classes.icon}>
                    <MdCheckCircle className={classes.icon} />
                  </IconButton>
                  <Typography mb={2}>
                    Les changement on bien été effectués avec succès
                  </Typography>

                  <Button
                    color="error"
                    variant="contained"
                    onClick={handleSuccess}
                  >
                    Fermer
                  </Button>
                </Box>
              </Modal>

              {/* Modal to show there was an error */}

              <Modal open={openFailed}>
                <Box className={classes.modal}>
                  <IconButton color="error" className={classes.icon}>
                    <MdError className={classes.icon} />
                  </IconButton>
                  <Typography mb={2}>{messageFailed}</Typography>
                  <Button
                    color="primary"
                    variant="contained"
                    onClick={() => setOpenFailed(false)}
                  >
                    Fermer
                  </Button>
                </Box>
              </Modal>
            </Box>
          </Grid>
        </Grid>
      </Box>
    </Box>
  );
}

function mapDispatchToProps(dispatch) {
  return {
    onSetToken: function (token) {
      dispatch({ type: "setToken", token: token });
    },
  };
}

function mapStateToProps(state) {
  return { token: state.token };
}

export default connect(mapStateToProps, mapDispatchToProps)(Settings);
